module.exports = __webpack_public_path__ + "img/yxlogo_white.65735bc7.png";